import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { EligibilityResponsePayload } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/eligibility.interface';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { DateService } from 'src/app/shared/services/date.service';
//import * as moment from 'moment';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { PageIndividualOnExchangePlanEnrollmentService } from '../../services/page-individual-on-exchange-plan-enrollment.service';
import { ProducerAuthorizationFormControlsAsJson } from 'src/app/angular-elements/shared/interfaces/on-exchange-eligibility-form.interface';

interface ProducerAuthorizationFormControls {
  attestation: AbstractControl;
}

// interface ProducerAuthorizationFormControlsAsJson {
//   attestation: boolean;
// }

@FormComponentLookup('marketplace-producer-authorization')
@Component({
    selector: 'app-marketplace-producer-authorization',
    templateUrl: './marketplace-producer-authorization.component.html',
    styleUrls: ['./marketplace-producer-authorization.component.scss'],
    standalone: false
})
export class MarketplaceProducerAuthorizationComponent extends FormEntryComponentClass implements OnInit, OnDestroy {

  producerAuthorizationForm: UntypedFormGroup;
  producerAuthorizationFormChangesSubscription: Subscription;

  nameNodeValue: string;
  signOrSubmissionDate: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dateService: DateService,
    private eligibilityManagerService: EligibilityManagerService,
    private pageIndividualOnExchangePlanEnrollmentService: PageIndividualOnExchangePlanEnrollmentService
  ) {
    super();
  }

  get producerAuthorizationFormControls(): ProducerAuthorizationFormControls {
    return this.producerAuthorizationForm.controls as unknown as ProducerAuthorizationFormControls;
  }

  ngOnDestroy() {
    this.producerAuthorizationFormChangesSubscription?.unsubscribe();
  }

  ngOnInit(): void {

    this.signOrSubmissionDate = moment(this.dateService.getNow()).format('MM/DD/YYYY');

    const eligibilityState: OnExchangeEligibilityStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];
    const matchedProspects = eligibilityState.prospects.filter(p => eligibilityState.currentProspectId === p.prospectId );

    if (matchedProspects.length > 0) {
      const prospect = matchedProspects[0];

      const producerInfoFromEligibilityData = this.eligibilityManagerService.getAgentInformation();
      if (
        producerInfoFromEligibilityData.fullName.firstName &&
        producerInfoFromEligibilityData.fullName.lastName &&
        producerInfoFromEligibilityData.npn
      ) {
        this.nameNodeValue = `${producerInfoFromEligibilityData.fullName.firstName} ${producerInfoFromEligibilityData.fullName.lastName}`;
      } else {
        const loginData: UserInfoStateStructure = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];
        if (
          loginData.basicUserInfo?.userType?.toUpperCase() === 'AGENT' ||
          loginData.basicUserInfo?.userType?.toUpperCase() === 'INTERNAL' ||
          loginData.basicUserInfo?.userType?.toUpperCase() === 'AGENCY_ADMIN'
        ) {
          this.nameNodeValue = `${loginData.basicUserInfo.firstName} ${loginData.basicUserInfo.lastName}`;
        }
      }


      /** Create Form */
      this.producerAuthorizationForm = this.fb.group({});
      /** Watch Form */
      this.setupSubscription();
      /** Populate Form */
      this.setupForm(prospect.data);
    }

  }

  setupSubscription() {

    this.producerAuthorizationFormChangesSubscription = this.producerAuthorizationForm.valueChanges
    .pipe(debounceTime(300))
    .subscribe((v: ProducerAuthorizationFormControlsAsJson) => {

      const dynamicObject = {};
      dynamicObject[this.entry.formControlAttributes.formControlName] = v;

      /** Update global form (trigger save to state) */
      this.form.patchValue(dynamicObject);
      this.pageIndividualOnExchangePlanEnrollmentService.reportValidity(this.producerAuthorizationForm, this.entry);

    });

  }

  setupForm(enrollData: EligibilityResponsePayload) {

    /** Attestion Checkbox */
    this.producerAuthorizationForm.addControl(
      'attestation',
      this.fb.control(false, [Validators.requiredTrue])
    );

    this.producerAuthorizationForm.updateValueAndValidity();
    this.pageIndividualOnExchangePlanEnrollmentService.reportValidity(this.producerAuthorizationForm, this.entry);
  }


}
